import { Tag } from "@chakra-ui/react";
import { t } from "i18next";
import { useCallback } from "react";
import { BidEvaluation } from "../../../../../../common/types";

export const useRecommendationTag = () => {
  const getRecommendationTag = useCallback((recommendation: BidEvaluation["recommendation"]) => {
    switch (recommendation) {
      case "recommended":
        return (
          <Tag backgroundColor="smSuccess" color="smBackground" rounded="full">
            {t("Recommended")}
          </Tag>
        );
      case "needs clarifications":
        return (
          <Tag backgroundColor="smWarning" color="smBackground" rounded="full">
            {t("Clarifications needed")}
          </Tag>
        );
      case "not recommended":
        return (
          <Tag backgroundColor="smDanger" color="smBackground" rounded="full">
            {t("Not recommended")}
          </Tag>
        );
    }
  }, []);

  return getRecommendationTag;
};
